import { colorsPalettes, colorsSets, rgba } from "@similarweb/styles";

import type { ICampaignPromoModalTheme } from "./types";

export const BLACK_FRIDAY_THEME: ICampaignPromoModalTheme = {
    backgroundBlurColor: colorsPalettes.blue[600],
    gradientPosition: "center",
    titleStyle: "uppercase",
    layout: "simple",
    modalSize: { width: "434px", height: "507px" },
};

export const CYBER_MONDAY_THEME: ICampaignPromoModalTheme = {
    backgroundBlurColor: colorsPalettes.purple[500],
    gradientPosition: "center",
    titleStyle: "uppercase",
    layout: "simple",
    modalSize: { width: "434px", height: "507px" },
};

export const NEW_YEAR_ANNUAL_THEME: ICampaignPromoModalTheme = {
    backgroundBlurColor: colorsPalettes.blue[600],
    gradientPosition: "center",
    titleStyle: "capitalize",
    layout: "simple",
    modalSize: { width: "434px", height: "507px" },
};

export const NEW_YEAR_CI_SEO_THEME: ICampaignPromoModalTheme = {
    backgroundBlurColor: colorsPalettes.blue[600],
    gradientPosition: "left",
    titleStyle: "capitalize",
    layout: "withFeatures",
    modalSize: { width: "760px", height: "442px" },
    featuresPanelBackground: colorsPalettes.midnight[500],
};

const AEO_MODAL_GRADIENT = `linear-gradient(180deg, ${colorsPalettes.carbon[500]} 0%, ${colorsSets.marketingGenAI.primary} 40%, ${colorsSets.marketingGenAI.accent} 100%)`;
const ANNUAL_MODAL_GRADIENT = `linear-gradient(34deg, ${colorsPalettes.blue[400]} 0%, ${colorsPalettes.blue[500]} 30.29%, ${colorsPalettes.midnight[400]} 70%, ${colorsPalettes.midnight[500]} 100%)`;

export const AEO_THEME: ICampaignPromoModalTheme = {
    background: AEO_MODAL_GRADIENT,
    gradientPosition: "left",
    titleStyle: "capitalize",
    titleFontVariant: "boldH3",
    titleSpanFontVariant: "boldH3",
    titleSpanFontWeight: 400,
    layout: "simple",
    modalSize: { width: "398px", height: "482px" },
    featuresPanelBackground: colorsPalettes.midnight[500],
};

export const ANNUAL_THEME: ICampaignPromoModalTheme = {
    background: ANNUAL_MODAL_GRADIENT,
    ctaButtonColor: colorsPalettes.blue[500],
    gradientPosition: "left",
    titleStyle: "none",
    titleFontVariant: "boldH3",
    titleSpanFontVariant: "h5",
    titleSpanFontWeight: 400,
    percentageFontVariant: "h5",
    layout: "simple",
    modalSize: { width: "434px", height: "465px" },
    featuresPanelBackground: colorsPalettes.midnight[500],
};

/** AEO theme with features panel layout (for ciAnnualToAeo scenario). */
export const AEO_WITH_FEATURES_THEME: ICampaignPromoModalTheme = {
    ...AEO_THEME,
    layout: "withFeatures",
    modalSize: { width: "729px", height: "422px" },
    featuresPanelBackground: rgba(colorsSets.marketingGenAI.secondary, 0.7),
};
const FIRST_WEEK_MODAL_GRADIENT = `linear-gradient(34deg, ${colorsPalettes.blue[400]} 0%, ${colorsPalettes.blue[500]} 30.29%, ${colorsPalettes.midnight[400]} 70%, ${colorsPalettes.midnight[500]} 100%)`;

export const FIRST_WEEK_THEME: ICampaignPromoModalTheme = {
    background: FIRST_WEEK_MODAL_GRADIENT,
    ctaButtonColor: colorsPalettes.blue[500],
    gradientPosition: "left",
    titleStyle: "none",
    titleFontVariant: "h3",
    titleSpanFontVariant: "boldH3",
    titleSpanFontWeight: 400,
    layout: "simple",
    modalSize: { width: "434px", height: "529px" },
    percentageFontVariant: "boldH4",
    featuresPanelBackground: colorsPalettes.midnight[500],
    timerBoxBackground: `linear-gradient(206deg, ${colorsPalettes.carbon[0]} -155.94%, ${rgba(colorsPalettes.carbon[0], 0)} 135.15%)`,
};
